var _path, _path2, _g, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiCurrencyItem3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63435 36.8608C9.25782 35.0457 10.9683 33.8264 12.8913 33.8264H46.6748C48.5726 33.8264 50.2664 35.0144 50.909 36.7962L57.8314 55.9896C58.8867 58.9156 56.7137 62.0002 53.5972 62.0002H6.29851C3.211 62.0002 1.04055 58.9685 2.04161 56.0542L8.63435 36.8608Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -13.1992,
    y: -30,
    width: 96.6348,
    height: 113.937
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_0_974_11212_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 30,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2605 27.4323L32.4662 52.3432C33.5928 54.4683 36.6435 54.4683 37.77 52.3431L50.9639 27.4527C52.5355 24.7561 53.4355 21.6218 53.4355 18.2776C53.4356 8.18321 45.2346 9.08373e-05 35.1181 8.99549e-05C25.0017 8.90724e-05 16.8007 8.18321 16.8007 18.2776C16.8007 21.1 17.4419 23.7729 18.5867 26.1594C18.5868 26.1596 18.5866 26.1598 18.5864 26.1598C18.5862 26.1598 18.5861 26.16 18.5862 26.1602L18.5959 26.1785C18.8015 26.6059 19.0233 27.0241 19.2605 27.4323Z",
    fill: "url(#paint0_linear_974_11212)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -13.1992,
    y: -30,
    width: 96.6348,
    height: 113.937
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_1_974_11212_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3917 27.3597L32.5988 52.2732C33.669 54.2921 36.5672 54.292 37.6374 52.2732L50.8327 27.3801L50.8342 27.3775C52.3929 24.7031 53.2855 21.5946 53.2855 18.2776C53.2856 8.26587 45.1517 0.149764 35.1181 0.149763C25.0846 0.149763 16.9507 8.26587 16.9507 18.2776C16.9507 21.0771 17.5866 23.728 18.722 26.0948C18.7234 26.0978 18.7248 26.1008 18.726 26.1039L18.7298 26.1111L18.7311 26.1137C18.935 26.5376 19.155 26.9523 19.3903 27.3572L19.3917 27.3597ZM18.6522 26.2945C18.6522 26.2945 18.6522 26.2945 18.6522 26.2945C18.6333 26.2559 18.6145 26.2172 18.5959 26.1785L18.5862 26.1602C18.5861 26.16 18.5862 26.1598 18.5864 26.1598C18.5866 26.1598 18.5868 26.1596 18.5867 26.1594C18.5866 26.1592 18.5865 26.159 18.5864 26.1588C18.5649 26.1141 18.5436 26.0692 18.5225 26.0242C18.5225 26.0242 18.5225 26.0242 18.5225 26.0242C17.4179 23.6722 16.8007 21.0468 16.8007 18.2776C16.8007 8.18321 25.0017 8.90724e-05 35.1181 8.99549e-05C45.2346 9.08373e-05 53.4356 8.18321 53.4355 18.2776C53.4355 21.6218 52.5355 24.7561 50.9639 27.4527L37.77 52.3431C36.6435 54.4683 33.5928 54.4683 32.4662 52.3432L19.2605 27.4323C19.0448 27.0611 18.8419 26.6816 18.6522 26.2945Z",
    fill: "url(#paint1_linear_974_11212)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3917 27.3597L32.5988 52.2732C33.669 54.2921 36.5672 54.292 37.6374 52.2732L50.8327 27.3801L50.8342 27.3775C52.3929 24.7031 53.2855 21.5946 53.2855 18.2776C53.2856 8.26587 45.1517 0.149764 35.1181 0.149763C25.0846 0.149763 16.9507 8.26587 16.9507 18.2776C16.9507 21.0771 17.5866 23.728 18.722 26.0948C18.7234 26.0978 18.7248 26.1008 18.726 26.1039L18.7298 26.1111L18.7311 26.1137C18.935 26.5376 19.155 26.9523 19.3903 27.3572L19.3917 27.3597ZM18.6522 26.2945C18.6522 26.2945 18.6522 26.2945 18.6522 26.2945C18.6333 26.2559 18.6145 26.2172 18.5959 26.1785L18.5862 26.1602C18.5861 26.16 18.5862 26.1598 18.5864 26.1598C18.5866 26.1598 18.5868 26.1596 18.5867 26.1594C18.5866 26.1592 18.5865 26.159 18.5864 26.1588C18.5649 26.1141 18.5436 26.0692 18.5225 26.0242C18.5225 26.0242 18.5225 26.0242 18.5225 26.0242C17.4179 23.6722 16.8007 21.0468 16.8007 18.2776C16.8007 8.18321 25.0017 8.90724e-05 35.1181 8.99549e-05C45.2346 9.08373e-05 53.4356 8.18321 53.4355 18.2776C53.4355 21.6218 52.5355 24.7561 50.9639 27.4527L37.77 52.3431C36.6435 54.4683 33.5928 54.4683 32.4662 52.3432L19.2605 27.4323C19.0448 27.0611 18.8419 26.6816 18.6522 26.2945Z",
    fill: "url(#paint2_radial_974_11212)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.119,
    cy: 18.3477,
    rx: 6.86903,
    ry: 6.85407,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_974_11212_clip_path",
    transform: "translate(13.1992 30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2605 27.4323L32.4662 52.3432C33.5928 54.4683 36.6435 54.4683 37.77 52.3431L50.9639 27.4527C52.5355 24.7561 53.4355 21.6218 53.4355 18.2776C53.4356 8.18321 45.2346 9.08373e-05 35.1181 8.99549e-05C25.0017 8.90724e-05 16.8007 8.18321 16.8007 18.2776C16.8007 21.1 17.4419 23.7729 18.5867 26.1594C18.5868 26.1596 18.5866 26.1598 18.5864 26.1598C18.5862 26.1598 18.5861 26.16 18.5862 26.1602L18.5959 26.1785C18.8015 26.6059 19.0233 27.0241 19.2605 27.4323Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_974_11212_clip_path",
    transform: "translate(13.1992 30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3917 27.3597L32.5988 52.2732C33.669 54.2921 36.5672 54.292 37.6374 52.2732L50.8327 27.3801L50.8342 27.3775C52.3929 24.7031 53.2855 21.5946 53.2855 18.2776C53.2856 8.26587 45.1517 0.149764 35.1181 0.149763C25.0846 0.149763 16.9507 8.26587 16.9507 18.2776C16.9507 21.0771 17.5866 23.728 18.722 26.0948C18.7234 26.0978 18.7248 26.1008 18.726 26.1039L18.7298 26.1111L18.7311 26.1137C18.935 26.5376 19.155 26.9523 19.3903 27.3572L19.3917 27.3597ZM18.6522 26.2945C18.6522 26.2945 18.6522 26.2945 18.6522 26.2945C18.6333 26.2559 18.6145 26.2172 18.5959 26.1785L18.5862 26.1602C18.5861 26.16 18.5862 26.1598 18.5864 26.1598C18.5866 26.1598 18.5868 26.1596 18.5867 26.1594C18.5866 26.1592 18.5865 26.159 18.5864 26.1588C18.5649 26.1141 18.5436 26.0692 18.5225 26.0242C18.5225 26.0242 18.5225 26.0242 18.5225 26.0242C17.4179 23.6722 16.8007 21.0468 16.8007 18.2776C16.8007 8.18321 25.0017 8.90724e-05 35.1181 8.99549e-05C45.2346 9.08373e-05 53.4356 8.18321 53.4355 18.2776C53.4355 21.6218 52.5355 24.7561 50.9639 27.4527L37.77 52.3431C36.6435 54.4683 33.5928 54.4683 32.4662 52.3432L19.2605 27.4323C19.0448 27.0611 18.8419 26.6816 18.6522 26.2945Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_11212",
    x1: 49.5152,
    y1: 48.9607,
    x2: 4.89071,
    y2: 33.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_974_11212",
    x1: 48.1634,
    y1: 55.8633,
    x2: 8.37564,
    y2: 40.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_974_11212",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-18.1146 32.9079 -22.3516 -69.3972 47.9606 1.76588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCurrencyItem3);
export default __webpack_public_path__ + "static/media/multi_currency_item3.1cb71ef3902651a8ccc6527fd5565e22.svg";
export { ForwardRef as ReactComponent };